// extracted by mini-css-extract-plugin
export default {"formContainer":"QuickAddForm_formContainer__RfZ6f","inputRow":"QuickAddForm_inputRow__dL0JM","saveButton":"QuickAddForm_saveButton__NS2nT"};